'use client';

import { TextPassage } from '@petsmart-ui/sparky';

export const CountdownHelper = () => {
    return (
        <TextPassage className="countdown-card__helper sparky-u-margin-top-xs" data-testid="countdown-helper">
            Orders $49+ ship free for Treats Rewards members
        </TextPassage>
    );
};
